import React from 'react';
import styled from 'styled-components';
import Media from 'react-media';
import { themes } from 'kb-shared';

import InjectionVideoButton from './InjectionVideoButton';
import { ReactComponent as TriggerSvg } from 'assets/icons/trigger.svg';
import { ReactComponent as AmSvg } from 'assets/icons/am.svg';
import { ReactComponent as PmSvg } from 'assets/icons/pm.svg';

interface Drug {
  name: string;
  amount: string;
  timeOfDay?: string | null;
  dailyRecurrence: number;
}

const Checklist = (props: { drugs: Drug[] }) => {
  return (
    <ChecklistContainer>
      {props.drugs.map(drug => {
        let timeOfDayIcon = null;
        if (drug.timeOfDay === 'AM') {
          timeOfDayIcon = <AmSvg />;
        } else if (drug.timeOfDay === 'PM') {
          timeOfDayIcon = <PmSvg />;
        }
        let recurrenceString = drug.dailyRecurrence ? `${drug.dailyRecurrence} times` : '';
        if (drug.dailyRecurrence <= 1) {
          recurrenceString = 'once';
        } else if (drug.dailyRecurrence === 2) {
          recurrenceString = 'twice';
        }

        return (
          <MedicationContainer key={drug.name} className="medication">
            <TriggerSvg />

            <Media query={{ minWidth: themes.breakpoints.raw.tabletPortrait }}>
              {tabletPortrait =>
                tabletPortrait ? (
                  <>
                    <DrugName>{drug.name}</DrugName>
                    <Column>
                      <InjectionVideoButton drugName={drug.name} key={drug.name} />
                    </Column>
                    <Column>
                      {drug.amount} taken {recurrenceString}
                    </Column>
                  </>
                ) : (
                  <>
                    <div>
                      <DrugName>{drug.name}</DrugName>
                      {drug.amount} taken {recurrenceString}
                    </div>
                    <Column>
                      <InjectionVideoButton drugName={drug.name} key={drug.name} />
                    </Column>
                  </>
                )
              }
            </Media>
            {timeOfDayIcon}
          </MedicationContainer>
        );
      })}
    </ChecklistContainer>
  );
};

export default Checklist;

const ChecklistContainer = styled.span``;

const MedicationContainer = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  background: ${({ theme }) => theme.colors.KBWhite};
  padding: 10px 12px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 40px auto auto 30px;
  grid-gap: 12px;
  align-items: center;
  font-size: 14px;

  & + & {
    margin-top: 2px;
  }

  @media screen and (min-width: ${({ theme }) => theme.largePhonePortrait}) {
    grid-template-columns: 40px auto 95px 30px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    grid-template-columns: 40px auto 95px 120px 30px;
  }
`;

const DrugName = styled.h4`
  ${({ theme }) => theme.fonts.DomaineDisplay};
  font-size: 24px;
  align-items: center;
  justify-content: flex-start;
`;

const Column = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
